import { jsx as _jsx } from "react/jsx-runtime";
import { MailClassicIcon } from "@jti/brand-icons/mail-classic";
import { FormField } from "../../../../../../components/Form";
import { TextInput } from "../../../../../../components/Inputs/TextInput/TextInput";
import styles from "./EmailInput.module.scss";
export const EmailInput = ({ placeholder }) => (_jsx("div", { className: styles.emailInputContainer, children: _jsx(FormField, { name: "email", className: styles.custom, showCustomError: true, validation: {
            required: "Field is required",
            validate: {
                emailValid: (value) => /\S+@\S+\.\S+/.test(value) || "Invalid email",
            },
        }, render: ({ field, fieldState }) => (_jsx(TextInput, { ...field, iconLeft: MailClassicIcon, placeholder: placeholder, containerClassName: styles.container, isError: fieldState.invalid, errorText: fieldState.error?.message || "", isHelperTextVisible: true })) }) }));
//# sourceMappingURL=EmailInput.js.map